import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=6ebfd25c&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
import style0 from "./alert.vue?vue&type=style&index=0&id=6ebfd25c&prod&lang=scss"
import style1 from "./alert.vue?vue&type=style&index=1&id=6ebfd25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfd25c",
  null
  
)

export default component.exports